import * as Sentry from '@sentry/browser';
import axios from 'axios';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import 'dayjs/locale/ru';

import { installSPInterceptor } from '@r1-frontend/do-request/lib/service-pipe/spResponseInterceptor';

import { IS_PRODUCTION_ENVIROMENT, SENTRY_DSN } from '~/src/constants';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

const bootstrap = () => {
    dayjs.locale('ru');
    dayjs.extend(customParseFormat);

    if (isClientSide()) {
        installSPInterceptor(axios);
    }

    Sentry.init({
        enabled: IS_PRODUCTION_ENVIROMENT,
        dsn: SENTRY_DSN,
        tracesSampleRate: 0.5,
        ignoreErrors: [
            'find variable: ym',
            'ym is not defined',
            'find variable: VK',
            'Vk is not defined',
            'fbq is not defined',
        ],
    });
};

export default bootstrap;
